"use strict";
/**
 * These are mostly storage keys
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PREFIX = 'identity';
exports.SSO_KEY = exports.PREFIX + '.sso';
exports.AUDIENCE_KEY = exports.PREFIX + '.audiences';
exports.AUTH_RESULT_KEY = exports.PREFIX + '.auth_result';
exports.REDIRECT_KEY = 'authRedirect';
exports.NONCE_KEY = 'nonces';
exports.STATE_KEY = 'state';
